"use client";

import { useEffect, useMemo, useState } from "react";
import { ChevronUp } from "lucide-react";

function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function ScrollToTopButton() {
  const thresholdPx = 420;
  const [visible, setVisible] = useState(false);

  const motion = useMemo(() => prefersReducedMotion(), []);

  useEffect(() => {
    let raf = 0;

    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        setVisible(window.scrollY > thresholdPx);
      });
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <button
      type="button"
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: motion ? "auto" : "smooth",
        });
      }}
      aria-label="Scroll to top"
      className={[
        "fixed bottom-5 right-5 z-50",
        "h-11 w-11 rounded-lg border border-[#2a475e] bg-[#16202d]/90 backdrop-blur",
        "text-[#c7d5e0] shadow-lg shadow-black/25",
        "hover:bg-[#1f2e3f] hover:text-white hover:border-[#66c0f4]/60",

        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#66c0f4]/40 focus-visible:ring-offset-0",
        "transition-all duration-200",
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-2 pointer-events-none",
      ].join(" ")}
    >
      <ChevronUp className="h-5 w-5 mx-auto" />
    </button>
  );
}
